import { Component } from "@angular/core";
import { trigger, transition, animate, style } from "@angular/animations";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";
import { BindingURLService } from "../../service/Bindingurlservice/binding-url.service";
import { NgxSpinnerService } from "ngx-spinner";
import { ApiService } from "../../service/apiUrls/apiUrl.service";

@Component({
  selector: "app-forgetPassword",
  styleUrls: ["forgetPassword.component.css"],
  templateUrl: "forgetPassword.component.html",
  animations: [
    trigger("slideInOut", [
      transition(":enter", [
        style({ transform: "translateY(-100%)" }),
        animate("200ms ease-in", style({ transform: "translateY(0%)" })),
      ]),
      transition(":leave", [
        animate("200ms ease-in", style({ transform: "translateY(-100%)" })),
      ]),
    ]),
  ],
})
export class ForgetPasswordComponent {
  images = [944, 1011, 984].map((n) => `https://picsum.photos/id/${n}/900/500`);
  type: string;
  message: string;
  alerts: any[] = [];
  menus: any[] = [];
  NewPass;
  NewConfirmPass;
  submenu: any[] = [];
  internalLinks: any[] = [];
  users: any[] = [];
  cookieValue = "UNKNOWN";

  emailVal;
  userName;
  visible: boolean = true;
  visible1: boolean = false;
  submitResetPass: boolean = true;
  TempPass;
  getEmailVal;
  confirmMailDisable = true;
  showChangePassword: boolean = false;
  PresentYearVal;
  constructor(
    private http: HttpClient,
    private spinner: NgxSpinnerService,
    private urlAuthentication: BindingURLService,
    private apiUrl: ApiService
  ) {
    sessionStorage.setItem("invUIToken", "");
    sessionStorage.setItem("user", "");
    let presentDate = new Date();
    this.PresentYearVal = presentDate.getFullYear();
  }

  getLoginApi(loginJson): Observable<any> {
    let uname = loginJson.username;
    let pswd = loginJson.password;
    const url = this.urlAuthentication.itocUrl + this.apiUrl.loginUrl;
    var authorizationBasic = window.btoa(uname + ":" + pswd);
    const httpHeaders = new HttpHeaders()
      .set("Accept", "application/json")
      .set("Authorization", "Basic " + authorizationBasic)
      .set("Content-type", "application/x-www-form-urlencoded; charset=utf-8");
    return this.http.get(url, { headers: httpHeaders, observe: "response" });
  }
  close(alert) {
    this.alerts.splice(this.alerts.indexOf(alert), 1);
  }

  addSubMenus(name) {
    this.submenu.push(name);
    return this.submenu;
  }

  LoginButton() {
    const link = "#/login";
    window.open(link, "_self", "");
  }
  NextEmail(userNam) {
    this.userName = userNam;
    let userName = { loginID: this.userName };
    this.http
      .post(this.urlAuthentication.jwtUrl + this.apiUrl.forgotPass, userName)
      .subscribe(
        (res) => {
          const getImgResp: string = JSON.stringify(res);
          const generateProcess = JSON.parse(getImgResp);
          let response = generateProcess.status;
          if (generateProcess.code === 2001) {
            this.alerts = [];
            this.alerts.push({
              type: "success",
              message: response,
            });
            const link = "#/updatePassword";
            window.open(link, "_self", "");
          } else {
            this.alerts = [];
            this.alerts.push({
              type: "danger",
              message: response,
            });
          }
        
        },
        (error) => {
          console.error(error);

          this.alerts = [];
          // this.alerts.push({
          //   type: "danger",
          //   message: "Please Enter Valid User Name",
          // });
          this.spinner.hide();
        }
      );
  }

  changeInputEmail(value) {
    this.confirmMailDisable;
    if (value == this.getEmailVal) {
      this.emailVal = value;
      this.confirmMailDisable = false;
      this.showChangePassword = false;
    } else {
      this.confirmMailDisable = true;
      this.showChangePassword = false;
    }
  }

  confirmEmail() {
    const loginJson = {
      UserName: this.userName,
      EmailId: this.emailVal,
    };
    this.http
      .post(
        this.urlAuthentication.itocUrl + this.apiUrl.forgetPassUrl,
        loginJson
      )
      .subscribe(
        (res) => {
          const getImgResp: string = JSON.stringify(res);
          const generateProcess = JSON.parse(getImgResp);
          this.showChangePassword = true;
          this.visible = false;
          this.visible1 = false;
          this.alerts = [];
          this.spinner.hide();
          this.alerts.push({
            type: "success",
            message: generateProcess,
          });
        },
        (error) => {
          console.error(error);

          this.alerts = [];
          this.alerts.push({
            type: "danger",
            message: "Log In failed, Please try again!!!",
          });
          this.spinner.hide();
        }
      );
  }

  submitResetPassword(userName, tempPass, newPass, CmfnewPass) {
    if (userName) {
      if (tempPass) {
        if (newPass == CmfnewPass) {
          let PostJson = {
            loginID: userName,
            tempPwd: tempPass,
            newPwd: newPass,
          };
          this.http
            .post(
              this.urlAuthentication.jwtUrl + this.apiUrl.changePasswordUrl,
              PostJson
            )
            .subscribe((res) => {
              const getImgResp: string = JSON.stringify(res);
              const generateProcess = JSON.parse(getImgResp);
              if (!generateProcess.response.Data.includes("Incorrect")) {
                this.alerts = [];
                this.alerts.push({
                  type: "success",
                  message: generateProcess.response.Data,
                });

                setTimeout(() => {
                  this.alerts = [];
                  const link = "#/login";
                  window.open(link, "_self", "");
                }, 5000);
              } else {
                this.alerts = [];
                this.alerts.push({
                  type: "danger",
                  message: generateProcess.response.Data,
                });
              }
            });
        } else {
          this.alerts = [];
          this.alerts.push({
            type: "danger",
            message: "Password doesn't match",
          });
        }
      } else {
        this.alerts = [];
        this.alerts.push({
          type: "danger",
          message: "Please Enter Temporary Password",
        });
      }
    } else {
      this.alerts = [];
      this.alerts.push({
        type: "danger",
        message: "Please Enter User Name",
      });
    }
  }
}
